import React, { useEffect, createRef } from "react";
import {createFormBuilderLink} from "../../../helpers"
import { Button } from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import BackIcon from '@mui/icons-material/ArrowBack';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import { useForm, Controller } from "react-hook-form";
import Checkbox from '@mui/material/Checkbox';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Scheduler from "material-ui-cron";
import NativeSelect from '@mui/material/NativeSelect';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel'; 
import { CreateInspectionBuilder, UpdateInspectionBuilder, getInspectionsById } from '../../../REST/inspections'
import {CreateForms} from "../../../REST/utilities"
import PageShell from '../../../themes/components/PageShell';
import PageHeader from '../../../themes/components/PageHeader';
import PageContent from '../../../themes/components/PageContent';
import Form from '../../../themes/components/Form';
import FormActions from '../../../themes/components/FormActions';





const CreateInspection = (props) => {
	const navigate = useNavigate()
	const location = useLocation()


	const isAddMode = location.pathname === "/settings/inspection/createInspection";
	const id = isAddMode ? null : location.pathname.replace("/settings/inspection/createInspection/", "")
	useEffect(() => {

		if (!isAddMode) 
		{
			getInspectionsById(id)
				.then((res) => {
					const data = res?.data
					const fields = ['expression', 'scheduled', 'name', 'module', 'description', 'formId','adhoc','status'];
					fields.forEach((field) => {
						setValue(field, data[field])
						if(field == 'scheduled') isScheduled(data[field])
					}
					);
				})
				.catch((e) => { navigate("/settings/inspection") })
		}
		else
		{
			CreateForms()
			.then(({data})=>{
				setValue("formId",data._id )
			})
		}
	}, []);

	const modulevalues = ["Property", "Agreement"]
	 

	const [scheduled, isScheduled] = React.useState(false);
	const gotoForm = (formId)=>{
		const url =createFormBuilderLink('build',formId)
		window.open(url, '_blank')
	}
 

	const schema = yup.object({
		expression: yup.string().trim(),
		scheduled: yup.boolean().required(),
		name: yup.string().trim().required(),
		module: yup.string().trim(),
		description: yup.string().trim().required(),
		formId:  yup.string().trim().required(),
		adhoc: yup.boolean().required(),
		status: yup.boolean().required(),
	}).required();


	const methods = useForm({
		defaultValues: {
			expression: '0 0 * * *',
			name: '',
			description: '',
			scheduled: false,
			module: '',
			formId:null,
			adhoc: true,
			status: true,
		},
		resolver: yupResolver(schema)
	});
	const { control,watch, register, getValues, setValue, clearErrors, reset, formState: { errors } } = methods;
	const watchAdhoc= watch("adhoc");

	const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

	const saveForm = (data) => {
		let newrecord = { ...data }
		 
		if(!newrecord.scheduled) delete newrecord.expression
		if(isAddMode) 
		{	

		  CreateInspectionBuilder(  newrecord )
		  .then(()=>{
			  navigate("/settings/inspection"); 
		  })
		}
		else	
		{
			UpdateInspectionBuilder(id,  newrecord )
			.then(()=>{
			  navigate("/settings/inspection"); 
			})
		}	
	}
	 
	 
	const getOptions = (opts = []) => {
		return [<option key='temp'>Select One</option>].concat(opts.map((e, idx) => {
			if (typeof e === 'string')
				return <option key={idx} value={e}>{e}</option>
			return <option key={idx} value={e._id}>{e.name}</option>
		}))
	}

	const FormBuilderControl = ({ errors, field }) => {
		const { name } = field
		return (
			<FormControl required error={isError(errors[name])} variant='standard' margin='dense' fullWidth>
				<input {...register(name)} type="hidden" />	
				<Button  onClick={() => { gotoForm( field.value) }} variant="outlined" >Form Builder</Button>

				{errors[name] && <FormHelperText>{errors[name].fields.message}</FormHelperText>}
			</FormControl>
		)
	}
	 



	const getCron = () => {

		const schema =
			{ type: 'expression', required: true, headerName: 'Expression', flex: 1, field: 'expression', grid: true };
		
		return <Controller key={schema.field} name={schema.field} control={control} 
					render={({ field }) => {
			
							return <CronInputAdd errors={errors} field={field} isAdd={true} />
			
					} } 
				/>

		
	}



	function CronInputAdd({ errors, field }) {

		const { name, value, onChange } = field
		 
		const [cronError, setCronError] = React.useState('') // get error message if cron is invalid
		//const [isAdmin, setIsAdmin] = React.useState(true) // set admin or non-admin to enable or disable high frequency scheduling (more than once a day)
		return (
			<Scheduler
				cron={value}
				setCron={(val)=> onChange(val)}
				setCronError={setCronError}
				isAdmin={true}
			/>
		)
	}
	return (
		<PageShell>
			<PageHeader
				title={isAddMode ? 'Create Inspection' : 'Edit Inspection'}
				back
				onBack={() => navigate(-1)}
			/>
			<PageContent>
				<Form methods={methods} onSubmit={saveForm}>
					<Controller name="name" control={control}
						render={({ field }) =>
							<TextField margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message}
								fullWidth label='Name' {...field} />} />
					<Controller name="description" control={control}
						render={({ field }) =>
							<TextField margin='dense' error={isError(errors.description)} helperText={errors.description && errors.description.message}
								fullWidth label='Description' {...field} />} />
					<Controller name="adhoc" control={control}
						render={({ field }) =>
							<FormControlLabel {...field} control={<Checkbox checked={field.value}  />} label="Is Adhoc" />} />				<Controller name="status" control={control}
					render={({ field }) =>
						<FormControlLabel {...field} control={<Checkbox checked={field.value}  />} label="Is Enabled?" />} />					{
						!watchAdhoc &&
						<Controller name="module" control={control}
							render={({ field }) =>
								<FormControl  error={isError(errors.module)} variant='standard' margin='dense' fullWidth>
									<InputLabel shrink>Module</InputLabel>
									<NativeSelect {...field} >{getOptions(modulevalues)}</NativeSelect>
									{errors.module && <FormHelperText>{errors.module.message}</FormHelperText>}</FormControl>} />
					}

					<Controller name="formId" control={control} render={({ field }) => <FormBuilderControl errors={errors} field={field} />} />

					<Controller name="scheduled" control={control}
						render={({ field }) =>
							<FormControlLabel {...field} control={<Checkbox checked={field.value}
								onInput={(evt) => { isScheduled(evt.target.checked) }} />} label="Is Scheduled" />} />

					{
						scheduled && getCron()
					}

					<FormActions>
						<Button type="submit" variant="outlined" startIcon={<SaveOutlined />}>
							Save Inspection
						</Button>
					</FormActions>
				</Form>
			</PageContent>
		</PageShell>
	)


}
export default CreateInspection;



